import { downloadFromBlob } from "../../../../../common/utils/download_utils";
import { IDownloadEquipamentoMedicaoArquivoUseCase } from "../../../presentation/useCases/read/download_equipamento_medicao_arquivo_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DownloadEquipamentoMedicaoArquivoUseCase
 */

export class DownloadEquipamentoMedicaoArquivoUseCase implements IDownloadEquipamentoMedicaoArquivoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async downloadEquipamentoMedicaoArquivo(
    idEquipamentoMedicao: number,
    nroArquivo: number,
    nomeArquivo: string,
  ): Promise<void> {
    const result = await this.repository.downloadEquipamentoMedicaoArquivo(
      idEquipamentoMedicao, nroArquivo);
    await downloadFromBlob(result, nomeArquivo);
  }
}
